var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.skinId)?_c('div',{staticClass:"skin-previewer",on:{"click":function($event){_vm.skinId = 0}}},[_c('b-img',{attrs:{"src":_vm.skinSrc,"fluid":"","alt":_vm.skinName}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }